import { Box, Paper } from '@mui/material';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  margin-bottom: 20px;
`;

export const StyledPaper = styled(Paper)`
  padding: 24px;
`;

export const StyledBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const StyledChipBox = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const StyledRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;
export const StyledSpan = styled.span`
  margin: 5px;
`;
export const StyledCompetitionSpan = styled.span`
  margin-left: 3%;
`;
